import {LogLevelType} from '../common'

import {ValidationFailedReasonType} from './common'
import {EasyBookingValidationFailedReasonType} from './easybooking'
import {ExceptionCode} from './exceptionCode'
import {MallValidationFailedReasonType} from './mall'
import {SellerValidationFailedReasonType} from './seller'

export const ReasonType = {
    ...ValidationFailedReasonType,
    ...MallValidationFailedReasonType,
    ...EasyBookingValidationFailedReasonType,
    ...SellerValidationFailedReasonType,
    ...ExceptionCode,
    /** 주문 상태가 유효하지 않습니다. */
    INVALID_ORDER_STATUS: 'INVALID_ORDER_STATUS',
    PAYMENT_DUE_DATE_EXPIRED: 'PAYMENT_DUE_DATE_EXPIRED',
    INVALID_PAY_METHOD_TYPE: 'INVALID_PAY_METHOD_TYPE',
    BLANK_MALL_PRODUCT_NAME: 'BLANK_MALL_PRODUCT_NAME',
    NONEXISTENT_MALL_PRODUCT: 'NONEXISTENT_MALL_PRODUCT',
    NULL_PRODUCT_URL: 'NULL_PRODUCT_URL',
    INVALID_PAY_NEXT_PAY_METHOD_TYPE: 'INVALID_PAY_NEXT_PAY_METHOD_TYPE',
    INVALID_PAY_METHOD: 'INVALID_PAY_METHOD',
    INVALID_PAY_METHOD_CARD_COMPANY_CODE: 'INVALID_PAY_METHOD_CARD_COMPANY_CODE',
    INVALID_PAY_METHOD_MOBILE_PHONE_NUMBER: 'INVALID_PAY_METHOD_MOBILE_PHONE_NUMBER',
    INVALID_PAY_METHOD_MOBILE_EASY_PAY_PIN: 'INVALID_PAY_METHOD_MOBILE_EASY_PAY_PIN',
    INVALID_PAY_METHOD_BANK_CODE: 'INVALID_PAY_METHOD_BANK_CODE',
    INVALID_PAY_METHOD_INSTALLMENT_MONTH: 'INVALID_PAY_METHOD_INSTALLMENT_MONTH',
    INVALID_PAY_METHOD_INSTALLMENT_CARD_OWNER_TYPE: 'INVALID_PAY_METHOD_INSTALLMENT_CARD_OWNER_TYPE',
    NOT_PERMITTED_INSTALLMENT_FOR_CHECK_CARD: 'NOT_PERMITTED_INSTALLMENT_FOR_CHECK_CARD',
    INVALID_ORDER_NO: 'INVALID_ORDER_NO',
    INVALID_PAY_REQUEST: 'INVALID_PAY_REQUEST',
    UNKNOWN_PAY_METHOD_TYPE: 'UNKNOWN_PAY_METHOD_TYPE',
    INVALID_PAY_LATER_PRODUCT_TYPE: 'INVALID_PAY_LATER_PRODUCT_TYPE',
    INVALID_PAY_LATER_WITH_PAY_NEXT: 'INVALID_PAY_LATER_WITH_PAY_NEXT',
    INVALID_PAY_LATER_WITH_CHARGE_POINT: 'INVALID_PAY_LATER_WITH_CHARGE_POINT',
    INVALID_PAY_AMOUNT: 'INVALID_PAY_AMOUNT',
    INVALID_GENERAL_PAY_AMOUNT: 'INVALID_GENERAL_PAY_AMOUNT',
    INVALID_DIFFERENT_PAY_METHOD_TYPE: 'INVALID_DIFFERENT_PAY_METHOD_TYPE',
    DEFAULT_ERROR_MESSAGE: 'DEFAULT_ERROR_MESSAGE',
    INQUIRE_ORDER_SHEET_FAILED: 'INQUIRE_ORDER_SHEET_FAILED',
    /** 최대할부기간을 초과할 수 없습니다 */
    FREE_INSTALLMENT_MONTH_LIMIT_EXCEEDED: 'FREE_INSTALLMENT_MONTH_LIMIT_EXCEEDED',
    /** 유효하지 않은 orderProcessId 로 인해 polling이 aborted 된 상태 */
    INVALID_ORDERPROCESS_ID: 'INVALID_ORDERPROCESS_ID',
    ORDER_PAY_MEMBER_NO_NOT_MATCHED: 'ORDER_PAY_MEMBER_NO_NOT_MATCHED',
    /** 가능한 무이자 할부 개월수를 초과했습니다. */
    FREE_INTEREST_INSTALLMENT_MONTH_LIMIT_EXCEEDED: 'FREE_INTEREST_INSTALLMENT_MONTH_LIMIT_EXCEEDED',
    /** 이미 결제요청이 진행중인 주문입니다 */
    ORDER_PROCESS_ALREADY_STARTED: 'ORDER_PROCESS_ALREADY_STARTED',
    /** 패밀리결제 설정이 변경되어 패밀리결제로 주문 불가합니다. 다른 결제수단으로 주문해주세요. */
    INVALID_FAMILY_PAY_AVAILABLE: 'INVALID_FAMILY_PAY_AVAILABLE',
    /**
     * 패밀리 주문이아닌데 결제하려는 경우
     * 패밀리결제 주문이 아닙니다
     **/
    NOT_FAMILY_PAY_ORDER: 'NOT_FAMILY_PAY_ORDER',
    /**
     * 네이버 멥버십이 아닌데 주문하려는 경우
     * 네이버멤버십에 가입되어 있지 않습니다. 네이버멥버십 가입 후 이용하여 주세요.
     **/
    NOT_SUBSCRIBED_MEMBERSHIP: 'NOT_SUBSCRIBED_MEMBERSHIP',
    /**
     * 주문건과 조회된 멤버십정보가 다른경우
     * 네이버멥버십 패밀리 정보가 올바르지 않습니다.
     **/
    NOT_SAME_MEMBERSHIP_ORGANIZER: 'NOT_SAME_MEMBERSHIP_ORGANIZER',
    /**
     * 멤버십정보가 스튜던트또는 올바르지 않는 케이스
     * 네이버멥버십 정보가 올바르지 않습니다.
     **/
    INVALID_MEMBERSHIP_TYPE: 'INVALID_MEMBERSHIP_TYPE',
    /**
     * 주문건의 결제자 정보와 로그인유저가 일치하지 않거나 결제가 본인이 접근하는 경우
     * 주문서의 패밀리결제 회원 정보가 올바르지 않습니다.
     **/
    INVALID_FAMILY_PAY_MEMBER_NO: 'INVALID_FAMILY_PAY_MEMBER_NO',
    /**
     * 패밀리결제 동의가 안된 케이스
     * 패밀리결제 설정이 변경되어 패밀리결제로 주문 불가합니다. 다른결제 수단으로 주문해주세요.
     **/
    NOT_AGREE_FAMILY_PAY_TERM: 'NOT_AGREE_FAMILY_PAY_TERM',
    /**
     * 패밀리결제  사용불가채널 타입 주문
     * 패밀리결제를 사용할 수 없는 주문입니다
     **/
    INVALID_SALE_CHANNEL_TYPE_FOR_FAMILY_PAY: 'INVALID_SALE_CHANNEL_TYPE_FOR_FAMILY_PAY',
    /**
     * 상품정보 변경
     * 요청 받은 상품이 패밀리결제 불가 상품으로 변경되어 결제가 불가능합니다.
     **/
    INVALID_PRODUCT_FOR_FAMILY_PAY: 'INVALID_PRODUCT_FOR_FAMILY_PAY',
    /**
     * 패밀리결제 (회원 api or 실적 api) 조회 실패
     * 일시적으로 패밀리결제 불가합니다.
     **/
    INVALID_FAMILY_PAY_API_RESPONSE: 'INVALID_FAMILY_PAY_API_RESPONSE',
    /**
     * 패밀리결제 회원 응답에 대표자정보가 없는 케이스
     * 패밀리결제 대표자 정보가 없습니다.
     **/
    INVALID_FAMILY_PAY_PAYER_MEMBER_NO: 'INVALID_FAMILY_PAY_PAYER_MEMBER_NO',
    /**
     * 사전승인결제인데 결제금액이 30만원 초과인 경우
     * 결제금액이 30만원 초과하여 결제완료할 수 없습니다. 결제방식을 확인해주세요.
     */
    EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT_PER_ORDER: 'EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT_PER_ORDER',
    /**
     * 자동결제로 결제시도시 월자동결제한도 초과한 경우
     * 월 결제한도를 초과하였습니다.
     */
    EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT: 'EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT',
    /**
     * 자동결제 가능 여부가 변경되었을 때
     * 패밀리결제 설정이 변경되어 바로 결제완료할 수 없습니다. 결제방식을 확인해주세요.
     */
    UNAVAILABLE_FAMILY_PAY_PRE_APPROVAL_PAYMENT: 'UNAVAILABLE_FAMILY_PAY_PRE_APPROVAL_PAYMENT',
    /** 통관고유부호 api 유효성 검증 실패 FE 검증 */
    PERSONAL_CUSTOMS_CLEARANCE_CHECK_FAIL: 'PERSONAL_CUSTOMS_CLEARANCE_CHECK_FAIL',
    /** 이미 사용한 쿠폰을 적용한 상태에서 예상적립포인트 조회 시 */
    INVALID_SELECTED_PRODUCT_COUPON: 'INVALID_SELECTED_PRODUCT_COUPON',
    /** 패밀리결제 정보 조회 실패 / 패밀리결제 결제수단 선택한 상태에서 예상적립포인트 조회 시 */
    INVALID_EXPECTED_REWARD_POINT_FETCH_BY_INVALID_FAMILY_PAY_INFO:
        'INVALID_EXPECTED_REWARD_POINT_FETCH_BY_INVALID_FAMILY_PAY_INFO',
    /** 플리마켓 주문이 불가합니다. 플리마켓 주문 정보가 유효한지 확인 후 다시 시도해주세요. */
    NOT_PURCHASABLE_FLEAMARKET_PRODUCT: 'NOT_PURCHASABLE_FLEAMARKET_PRODUCT',
    /** 알수없음 */
    UNKNOWN: 'UNKNOWN',
} as const

export type ReasonTypeType = Constant<typeof ReasonType>

/**
 * 서버 코드 오류 구분
 * - key 를 string 으로 정의한 이유는 중복을 제거하기 위함
 **/
export const ReasonTypeInfoMap: Record<
    ReasonTypeType,
    {
        level: LogLevelType
    }
> = {
    BLACK_CONSUMER: {level: 'WARN'},
    /** 배송지 정보를 입력해야 합니다. */
    BLANK_DELIVERY_ADDRESS_INFORMATION: {level: 'ERROR'},
    BLANK_DELIVERY_ADDRESS_NOT_ROAD_DETAIL_ADDRESS: {level: 'ERROR'},
    /** 수령인을 입력해야 합니다. */
    BLANK_DELIVERY_ADDRESS_RECEIVER_NAME: {level: 'ERROR'},
    BLANK_DELIVERY_NOTHING_ORDER_RECEIVER_NAME: {level: 'ERROR'},
    BLANK_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE: {level: 'ERROR'},
    BLANK_REFUND_ACCOUNT_BANK_INFORMATION: {level: 'ERROR'},
    /** 네이버페이 머니 사용자 상태가 올바르지 않습니다. 다시 시도해 주세요. */
    CHARGE_POINT_USER_STATUS_NOT_MATCHED: {level: 'WARN'},
    /** 배송 메모는 최대 500자까지 입력 가능합니다. */
    DELIVERY_MEMO_LENGTH_LIMIT_EXCEEDED: {level: 'ERROR'},
    /** 선택하신 배송지 우편번호가 폐지되어 사용 불가합니다. */
    DEPRECATED_DELIVERY_ADDRESS_ZIPCODE: {level: 'ERROR'},
    DETAIL_ADDRESS_LENGTH_LIMIT_EXCEEDED: {level: 'WARN'},
    /** 같은 배송비 쿠폰을 중복 사용할 수 없습니다. */
    DUPLICATED_SELECTED_DELIVERY_FEE_COUPON: {level: 'ERROR'},
    /** 같은 상품 쿠폰을 중복 사용할 수 없습니다. */
    DUPLICATED_SELECTED_PRODUCT_COUPON: {level: 'ERROR'},
    /** 보유한 네이버페이 머니 보다 많은 금액은 사용하실 수 없습니다. 다시 주문해주세요. */
    EXCEED_CHARGE_POINT_BALANCE_AMOUNT: {level: 'WARN'},
    /** 배송지명은 최대 50자까지 입력 가능합니다. */
    EXCEED_DELIVERY_ADDRESS_NAME: {level: 'ERROR'},
    EXCEED_DELIVERY_ADDRESS_RECEIVER_NAME: {level: 'ERROR'},
    EXCEED_DELIVERY_NOTHING_ORDER_RECEIVER_NAME: {level: 'ERROR'},
    /** 월 결제한도 45만원 금액 초과로 결제가 불가능합니다. */
    EXCEED_MINOR_PAY_AMOUNT: {level: 'WARN'},
    /** 결제시 사용할 수 있는 한도 금액을 초과하였습니다. */
    EXCEED_PAY_LATER_AVAILABLE_AMOUNT: {level: 'WARN'},
    /**
     * 충전 가능 금액이 부족하여 네이버페이 머니 충전결제 이용이 불가합니다.
     * - 충전금 재조회가 필요할까?
     **/
    EXCEED_RECHARGE_LIMIT: {level: 'WARN'},
    /** 보유한 네이버페이 포인트 보다 많은 금액은 사용하실 수 없습니다. 다시 주문해주세요. */
    EXCEED_REWARD_POINT_BALANCE_AMOUNT: {level: 'WARN'},
    /** 모바일쿠폰/상품권 및 지류/상품권 카테고리 상품 일 결제금액 한도 50만원을 초과하여 결제가 불가합니다. */
    EXCEED_TODAY_GIFT_CERTIFICATION_USAGE_AMOUNT: {level: 'WARN'},
    /** 네이버페이 머니 잔액 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_CHARGE_POINT_BALANCE: {level: 'WARN'},
    FAILED_GET_CHARGE_POINT_BALANCE_TPS_EXCEED: {level: 'WARN'},
    FAILED_GET_CHARGE_POINT_BALANCE_BANK_MAINTENANCE: {level: 'WARN'},
    FAILED_GET_CHARGE_POINT_USER: {level: 'WARN'},
    FAILED_GET_RECHARGEABLE_CHARGE_POINT_AMOUNT: {level: 'WARN'},
    FAILED_GET_MINOR_PAY_AMOUNT: {level: 'WARN'},
    FAILED_GET_REWARD_POINT_BALANCE: {level: 'WARN'},
    /** 최대할부기간을 초과할 수 없습니다 */
    INSTALLMENT_MONTH_LIMIT_EXCEEDED: {level: 'ERROR'},
    /** 현금영수증 정보가 잘못되었습니다. */
    INVALID_CASH_RECEIPT: {level: 'ERROR'},
    INVALID_CASH_RECEIPT_BUSINESS_REGISTRATION_NUMBER: {level: 'WARN'},
    INVALID_CASH_RECEIPT_PR_CELL_PHONE_NUMBER: {level: 'WARN'},
    INVALID_CASH_RECEIPT_PR_CASH_RECEIPT_CARD_NUMBER: {level: 'WARN'},
    /** 현금영수증 전용카드는 총 18자리 입니다. 정확한 카드번호를 입력해 주세요. */
    INVALID_CASH_RECEIPT_PR_CASH_RECEIPT_VOLUNTARY_ISSUANCE_CARD_NUMBER: {level: 'ERROR'},
    INVALID_CHARGE_POINT_AMOUNT: {level: 'ERROR'},
    /** 연락처1의 입력하신 정보를 확인해 주세요. */
    INVALID_FORMAT_DELIVERY_ADDRESS_TEL_NO1: {level: 'ERROR'},
    /** 연락처2의 입력하신 정보를 확인해 주세요. */
    INVALID_FORMAT_DELIVERY_ADDRESS_TEL_NO2: {level: 'ERROR'},
    /** 우편번호는 5,6자리 숫자만 허용합니다. */
    INVALID_FORMAT_DELIVERY_ADDRESS_ZIPCODE: {level: 'ERROR'},
    /** 선택하신 배송지의 우편번호 혹은 주소명이 정확하지 않습니다. 원활한 배송을 위해 배송지 정보를 업데이트 해주세요. */
    INVALID_ZIPCODE_AND_ADDRESS: {level: 'ERROR'},
    /** 상품 수신을 위한 휴대폰 번호를 입력해 주세요. */
    INVALID_FORMAT_DELIVERY_NOTHING_ORDER_RECEIVER_PHONE_NUMBER: {level: 'ERROR'},
    /** 개인통관고유부호를 정확히 입력해주세요.) */
    INVALID_FORMAT_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE: {level: 'WARN'},
    /** 카드사를 선택하셔야 합니다. */
    INVALID_GENERAL_PAY_METHOD_CARD_COMPANY_CODE: {level: 'ERROR'},
    /** 결제수단 정보가 잘못되었습니다. */
    INVALID_GENERAL_PAY_METHOD_CARD_INSTALLMENT: {level: 'ERROR'},
    /** 할부기간을 선택하셔야 합니다. */
    INVALID_GENERAL_PAY_METHOD_CARD_INSTALLMENT_MONTH: {level: 'ERROR'},
    /** 휴대폰 간편결제 비밀번호 4자리를 입력해 주십시오. */
    INVALID_GENERAL_PAY_METHOD_MOBILE_EASY_PAY_PIN_NO: {level: 'ERROR'},
    /** 휴대폰번호를 입력해주세요. | 잘못된 휴대폰 번호입니다. */
    INVALID_GENERAL_PAY_METHOD_MOBILE_PHONE_NUMBER: {level: 'ERROR'},
    INVALID_GENERAL_PAY_METHOD_SKIP: {level: 'ERROR'},
    INVALID_GENERAL_PAY_METHOD_TYPE: {level: 'ERROR'},
    INVALID_GENERAL_PAY_METHOD_TYPE_PAY_AMOUNT: {level: 'ERROR'},
    INVALID_GENERAL_PAY_METHOD_VIRTUAL_ACCOUNT_BANK_CODE: {level: 'ERROR'},
    INVALID_GIFT_CERTIFICATION_USAGE_AMOUNT: {level: 'ERROR'},
    INVALID_ITEM_PAY_AMOUNT: {level: 'ERROR'},
    /** 주문 금액이 올바르지 않습니다. 주문서를 새로고침 후 확인해주시기 바랍니다. */
    INVALID_ORDER_PAY_AMOUNT: {level: 'WARN'},
    INVALID_PAY_LATER_ORDER: {level: 'ERROR'},
    INVALID_PAY_LATER_PAY_AMOUNT: {level: 'ERROR'},
    INVALID_PAY_LATER_RECHARGE_POINT: {level: 'ERROR'},
    INVALID_PAY_LATER_SKIP: {level: 'ERROR'},
    INVALID_PAY_LATER_USER_OVERDUE_PENALTY_STATUS: {level: 'ERROR'},
    /** 후불 결제를 사용할 수 없는 회원 상태입니다. */
    INVALID_PAY_LATER_USER_STATUS: {level: 'WARN'},
    /** 후불결제시 포인트가 전액 사용되어야 합니다. */
    INVALID_PAY_LATER_WITH_NOT_USE_ALL_POINTS: {level: 'WARN'},
    INVALID_PAY_REQUEST: {level: 'ERROR'},
    INVALID_RECHARGE_AMOUNT: {level: 'ERROR'},
    INVALID_RECHARGE_POINT_AMOUNT: {level: 'ERROR'},
    INVALID_REWARD_POINT_AMOUNT: {level: 'ERROR'},
    /** 사용할 수 없는 쿠폰입니다. 주문서를 새로고침 하거나 다시 진입해주세요 */
    INVALID_SELECTED_DELIVERY_FEE_COUPON: {level: 'WARN'},
    INVALID_SELECTED_PRODUCT_COUPON: {level: 'WARN'},
    INVALID_SUB_PAY_METHOD_TYPE: {level: 'ERROR'},
    INVALID_SUB_PAY_METHOD_TYPE_PAY_AMOUNT: {level: 'ERROR'},
    /** 유효하지 않은 회원입니다. */
    MEMBER_NO_NOT_MATCHED: {level: 'WARN'},
    MEMBERSHIP_QUICK_JOIN_FAILED_ALREADY_SUBSCRIBED: {level: 'WARN'},
    MEMBERSHIP_QUICK_JOIN_FAILED_ALREADY_SUBSCRIBED_WITH_NAVER_ID: {level: 'WARN'},
    MEMBERSHIP_QUICK_JOIN_FAILED_RESUBSCRIBE_ON_THE_SAME_DAY: {level: 'WARN'},
    MEMBERSHIP_QUICK_JOIN_FAILED_UNCATEGORIZED_ERROR: {level: 'WARN'},
    /** 유효하지 않은 가맹점 입니다. */
    MERCHANT_STATUS_NOT_NORMAL: {level: 'WARN'},
    /** 환불방법을 선택하세요. */
    MISSING_REFUND_ACCOUNT_METHOD_TYPE: {level: 'ERROR'},
    /** 페이 휴대폰 결제 가능 최대 금액을 초과하여, 휴대폰 결제를 진행할 수 없습니다. */
    MOBILE_PAYMENT_LIMIT_EXCEEDED: {level: 'WARN'},
    /** 네이버 회원 인증에 실패하였습니다? */
    NAVERPAY_AUTHENTICATION_VALIDATION_FAILED: {level: 'ERROR'},
    // FE 에서 비밀번호가 변경되었으면 apply 까지 안보냄
    NAVERPAY_AUTHENTICATION_VALIDATION_FAILED_PASSWORD_RESET: {level: 'ERROR'},
    /** 해외직배송 상품 통관처리를 위한 고유식별정보 수집 및 제공 동의에 체크해 주세요. */
    NOT_AGREED_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_COLLECTION: {level: 'ERROR'},
    /** 주문자의 휴대폰 번호와 수신자의 휴대폰 번호가 일치하지 않습니다? */
    NOT_MATCHED_DELIVERY_NOTHING_ORDER_PURCHASER_PHONE_NUMBER: {level: 'WARN'},
    /** 개인 통관 고유부호 필요 여부를 선택해 주세요. */
    NULL_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_NEEDED: {level: 'ERROR'},
    ORDER_ALREADY_CREATED: {level: 'WARN'},
    ORDER_APPLY_REQUIREMENT_MISSING: {level: 'ERROR'},
    REFRESHED_CHARGE_POINT_USER_STATUS: {level: 'WARN'},
    /** 해외직배송상품은 통관진행 및 원활한 배송처리를 위해 도로명주소+5자리 우편번호로 입력하셔야 합니다.\n배송지 주소를 도로명 주소로 수정해주세요. */
    REJECT_OVERSEA_DELIVERY_NOT_ROAD_ADDRESS: {level: 'WARN'},
    REJECT_RECHARGE_PAYMENT_OF_OPENED_USER_WITH_ENOUGH_BALANCE: {level: 'WARN'},
    /** 선택하신 국번은 안심번호 이용신청이 불가합니다. */
    REJECT_VIRTUAL_PHONE_NUMBER_DELIVERY_ADDRESS_TEL_NO1: {level: 'WARN'},
    REJECT_VIRTUAL_PHONE_NUMBER_DELIVERY_ADDRESS_TEL_NO2: {level: 'WARN'},
    /** 해당 판매자의 상품은 수입신고 진행을 위해 안심번호 서비스 제공이 불가합니다. */
    REJECT_VIRTUAL_PHONE_NUMBER_OVERSEA_DELIVERY: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. */
    REMOTE_API_SERVER_ERROR: {level: 'WARN'},
    TICKET_EXPIRED: {level: 'WARN'},
    /** 네이버페이 머니 충전결제를 사용할 수 없는 사용자 상태입니다. */
    UNAVAILABLE_CHARGE_POINT_USER_STATUS: {level: 'WARN'},
    /** 후불결제 시스템 점검 중입니다. 다른 결제수단을 이용해 주세요. */
    UNAVAILABLE_PAY_LATER_SERVICE: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. */
    UNCATEGORIZED_ERROR: {level: 'WARN'},
    /** 개인고유통관부호가 필요하지 않은 주문입니다. 재시도 또는 고객센터 문의바랍니다. */
    UNNECESSARY_PERSONAL_CUSTOMS_CODE: {level: 'ERROR'},
    VERIFY_SERVER_CLIENT_DATA_DO_NOT_MATCH: {level: 'ERROR'},
    /** 현재 안심번호 서비스가 일시 중단된 상태입니다. 안심번호 사용신청이 취소됩니다. */
    VIRTUAL_PHONE_NUMBER_SERVICE_UNAVAILABLE: {level: 'WARN'},
    EXCESS_DELIVERY_ADDRESS_NAME: {level: 'ERROR'},
    EXCESS_DELIVERY_ADDRESS_RECEIVER_NAME: {level: 'ERROR'},
    EXCESS_DELIVERY_NOTHING_ORDER_RECEIVER_NAME: {level: 'ERROR'},
    INVALID_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE: {level: 'ERROR'},
    /** 유효하지 않은 가맹점 입니다. */
    MERCHANT_STATUS: {level: 'WARN'},
    ORDER_SHEET_NOT_FOUND: {level: 'WARN'},
    /** 해외직배송 상품 통관처리를 위한 고유식별정보 수집 및 제공 동의에 체크해 주세요. */
    NOT_AGREED_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_PROVIDE_TO_MERCHANT: {level: 'ERROR'},
    /** 주문추가정보를 입력할 수 없는 주문입니다. */
    INVALID_ADDITIONAL_ORDER_OPTIONS_VERSION: {level: 'ERROR'},
    NOT_FOUND_ADDITIONAL_ORDER_OPTION: {level: 'ERROR'},
    MISSING_MANDATORY_ADDITIONAL_ORDER_OPTION: {level: 'ERROR'},
    NOT_FOUND_MANDATORY_ADDITIONAL_ORDER_OPTION: {level: 'ERROR'},
    EXCEED_SELECTED_COUPON_APPLY_COUNT: {level: 'ERROR'},
    ORDER_SHEET_ITEM_LIST_CHECK_FAILED: {level: 'WARN'},
    MALL_PRODUCT_INVALID_MERCHANT_PRODUCT_QUERY_ENDPOINT: {level: 'WARN'},
    MALL_PRODUCT_ERROR_OCCURRED_WHILE_QUERYING: {level: 'WARN'},
    MALL_PRODUCT_NONEXISTENT: {level: 'WARN'},
    MALL_PRODUCT_BLANK_NAME: {level: 'WARN'},
    MALL_PRODUCT_NULL_URL: {level: 'WARN'},
    MALL_PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_BLANKS: {level: 'WARN'},
    MALL_PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS: {
        level: 'WARN',
    },
    MALL_PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    MALL_PRODUCT_MERCHANT_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_NULL_SALE_PRICE: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_SALE_PRICE: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_ZERO_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_INSUFFICIENT_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_SOLD_OUT_STATUS_TYPE: {level: 'WARN'},
    MALL_PRODUCT_NOT_ON_SALE_STATUS_TYPE: {level: 'WARN'},
    MALL_PRODUCT_NULL_DELIVERY_POLICY: {level: 'WARN'},
    MALL_PRODUCT_NULL_DELIVERY_FEE_CLASS_TYPE: {level: 'WARN'},
    MALL_PRODUCT_NULL_DELIVERY_FEE_PAY_TYPE: {level: 'WARN'},
    MALL_PRODUCT_NULL_DELIVERY_BASE_FEE: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_DELIVERY_BASE_FEE: {level: 'WARN'},
    MALL_PRODUCT_DELIVERY_BASE_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    MALL_PRODUCT_ZERO_DELIVERY_BASE_FEE: {level: 'WARN'},
    MALL_PRODUCT_NON_POSITIVE_REPEAT_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_NULL_SECOND_BASE_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_NON_POSITIVE_SECOND_BASE_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_SECOND_EXTRA_FEE: {level: 'WARN'},
    MALL_PRODUCT_SECOND_EXTRA_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    MALL_PRODUCT_THIRD_BASE_QUANTITY_LESS_THAN_OR_EQUAL_TO_SECOND_BASE_QUANTITY: {
        level: 'WARN',
    },
    MALL_PRODUCT_NEGATIVE_THIRD_EXTRA_FEE: {level: 'WARN'},
    MALL_PRODUCT_THIRD_EXTRA_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_DELIVERY_AREA2_EXTRA_FEE: {level: 'WARN'},
    MALL_PRODUCT_DELIVERY_AREA2_EXTRA_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_DELIVERY_AREA3_EXTRA_FEE: {level: 'WARN'},
    MALL_PRODUCT_DELIVERY_AREA3_EXTRA_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    MALL_PRODUCT_NEW_OPTION_ITEMS_CREATED: {level: 'WARN'},
    MALL_PRODUCT_NONEXISTENT_OPTION_ITEM: {level: 'WARN'},
    MALL_PRODUCT_NONEXISTENT_OPTION_ITEM_VALUE: {level: 'WARN'},
    MALL_PRODUCT_NULL_OPTION_ITEM_NAME: {level: 'WARN'},
    MALL_PRODUCT_OPTION_ITEM_NAME_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_OPTION_ITEM_ID_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_OPTION_ITEM_ID_CONTAINING_BLANKS: {level: 'WARN'},
    MALL_PRODUCT_OPTION_ITEM_ID_CONTAINING_KOREAN_CHARACTERS: {level: 'WARN'},
    MALL_PRODUCT_OPTION_ITEM_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    MALL_PRODUCT_NULL_OPTION_ITEM_TEXT: {level: 'WARN'},
    MALL_PRODUCT_OPTION_ITEM_TEXT_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_CHANGED_OPTION_ITEM_VALUE_TEXT: {level: 'WARN'},
    MALL_PRODUCT_UNAVAILABLE_OPTION_ITEM_VALUE: {level: 'WARN'},
    MALL_PRODUCT_NONEXISTENT_COMBINATION: {level: 'WARN'},
    MALL_PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH: {
        level: 'WARN',
    },
    MALL_PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_BLANKS: {level: 'WARN'},
    MALL_PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS: {
        level: 'WARN',
    },
    MALL_PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {level: 'WARN'},
    MALL_PRODUCT_COMBINATION_PRICE_LESS_THAN_MINUS_50_PERCENT_OF_SALE_PRICE: {
        level: 'WARN',
    },
    MALL_PRODUCT_NEGATIVE_COMBINATION_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_ZERO_COMBINATION_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_INSUFFICIENT_COMBINATION_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_UNAVAILABLE_COMBINATION: {level: 'WARN'},
    MALL_PRODUCT_NULL_COMBINATION_OPTION_NAME: {level: 'WARN'},
    MALL_PRODUCT_COMBINATION_OPTION_NAME_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_COMBINATION_OPTION_ID_CONTAINING_BLANKS: {level: 'WARN'},
    MALL_PRODUCT_COMBINATION_OPTION_ID_CONTAINING_KOREAN_CHARACTERS: {level: 'WARN'},
    MALL_PRODUCT_COMBINATION_OPTION_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    MALL_PRODUCT_CHANGED_COMBINATION_OPTIONS: {level: 'WARN'},
    MALL_PRODUCT_NONEXISTENT_SUPPLEMENT: {level: 'WARN'},
    MALL_PRODUCT_SUPPLEMENT_ID_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_SUPPLEMENT_ID_CONTAINING_BLANKS: {level: 'WARN'},
    MALL_PRODUCT_SUPPLEMENT_ID_CONTAINING_KOREAN_CHARACTERS: {level: 'WARN'},
    MALL_PRODUCT_SUPPLEMENT_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    MALL_PRODUCT_NULL_SUPPLEMENT_NAME: {level: 'WARN'},
    MALL_PRODUCT_SUPPLEMENT_NAME_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    MALL_PRODUCT_CHANGED_SUPPLEMENT_NAME: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_SUPPLEMENT_PRICE: {level: 'WARN'},
    MALL_PRODUCT_NEGATIVE_SUPPLEMENT_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_ZERO_SUPPLEMENT_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_INSUFFICIENT_SUPPLEMENT_STOCK_QUANTITY: {level: 'WARN'},
    MALL_PRODUCT_UNAVAILABLE_SUPPLEMENT: {level: 'WARN'},
    ORDER_APPLY_REQUIREMENT_LENGTH_INVALID: {level: 'WARN'},
    DUPLICATE_PRODUCT_COUPON: {level: 'WARN'},
    CAFE_MERCHANT_IDENTICAL_TO_CUSTOMER: {level: 'WARN'},
    FLEAMARKET_MERCHANT_IDENTICAL_TO_CUSTOMER: {level: 'WARN'},
    EXCEED_CAFE_MERCHANT_SIZE: {level: 'WARN'},
    INVALID_EASYBOOKING_POINT_USAGE: {level: 'ERROR'},
    INVALID_EASYBOOKING_COUPON_USAGE: {level: 'ERROR'},
    INVALID_EASYBOOKING_CARD_COMPANY_CODE: {level: 'ERROR'},
    OUT_OF_STOCK: {level: 'WARN'},
    PRODUCT_NULL_URL: {level: 'WARN'},
    PRODUCT_NEGATIVE_SALE_PRICE: {level: 'WARN'},
    PRODUCT_NULL_SALE_PRICE: {level: 'WARN'},
    PRODUCT_NOT_ON_SALE_STATUS_TYPE: {level: 'WARN'},
    PRODUCT_NONEXISTENT: {level: 'WARN'},
    PRODUCT_NEW_OPTION_ITEMS_CREATED: {level: 'WARN'},
    PRODUCT_NONEXISTENT_OPTION_ITEM_VALUE: {level: 'WARN'},
    PRODUCT_NULL_OPTION_ITEM_NAME: {level: 'WARN'},
    PRODUCT_OPTION_ITEM_NAME_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    PRODUCT_OPTION_ITEM_ID_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    PRODUCT_OPTION_ITEM_ID_CONTAINING_BLANKS: {level: 'WARN'},
    PRODUCT_OPTION_ITEM_ID_CONTAINING_KOREAN_CHARACTERS: {level: 'WARN'},
    PRODUCT_OPTION_ITEM_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    PRODUCT_NULL_OPTION_ITEM_TEXT: {level: 'WARN'},
    PRODUCT_OPTION_ITEM_TEXT_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    PRODUCT_CHANGED_OPTION_ITEM_VALUE_TEXT: {level: 'WARN'},
    PRODUCT_NONEXISTENT_COMBINATION: {level: 'WARN'},
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH: {
        level: 'WARN',
    },
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_BLANKS: {level: 'WARN'},
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS: {
        level: 'WARN',
    },
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {level: 'WARN'},
    PRODUCT_NEGATIVE_COMBINATION_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_ZERO_COMBINATION_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_INSUFFICIENT_COMBINATION_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_NULL_COMBINATION_OPTION_NAME: {level: 'WARN'},
    PRODUCT_COMBINATION_OPTION_NAME_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    PRODUCT_COMBINATION_OPTION_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    PRODUCT_COMBINATION_OPTION_ID_CONTAINING_KOREAN_CHARACTERS: {level: 'WARN'},
    PRODUCT_COMBINATION_OPTION_ID_CONTAINING_BLANKS: {level: 'WARN'},
    PRODUCT_CHANGED_COMBINATION_OPTIONS: {level: 'WARN'},
    PRODUCT_NEGATIVE_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_ZERO_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_INSUFFICIENT_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_SOLD_OUT_STATUS_TYPE: {level: 'WARN'},
    PRODUCT_MERCHANT_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH: {level: 'WARN'},
    PRODUCT_EMPTY_MERCHANT_MANAGEMENT_CODE: {level: 'WARN'},
    PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_BLANKS: {level: 'WARN'},
    PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS: {
        level: 'WARN',
    },
    PRODUCT_BLANK_NAME: {level: 'WARN'},
    PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS: {
        level: 'WARN',
    },
    PRODUCT_NULL_DELIVERY_POLICY: {level: 'WARN'},
    PRODUCT_NULL_DELIVERY_FEE_CLASS_TYPE: {level: 'WARN'},
    PRODUCT_NULL_DELIVERY_FEE_PAY_TYPE: {level: 'WARN'},
    PRODUCT_NULL_DELIVERY_BASE_FEE: {level: 'WARN'},
    PRODUCT_NEGATIVE_DELIVERY_BASE_FEE: {level: 'WARN'},
    PRODUCT_DELIVERY_BASE_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    PRODUCT_ZERO_DELIVERY_BASE_FEE: {level: 'WARN'},
    PRODUCT_NULL_FREE_CONDITIONAL_AMOUNT: {level: 'WARN'},
    PRODUCT_NEGATIVE_DELIVERY_AREA2_EXTRA_FEE: {level: 'WARN'},
    PRODUCT_DELIVERY_AREA2_EXTRA_FEE_GREAT_THAN_MAX_LIMIT: {level: 'WARN'},
    EXIST_VALID_EASYBOOKING_RESERVATION: {level: 'WARN'},
    NO_PAY_METHODS_REGISTERED: {level: 'ERROR'},
    FDS_FAILED: {level: 'WARN'},
    NO_AVAILABLE_PAY_METHODS: {level: 'ERROR'},
    CARD_EASY_PAY_INVALID_PAY_AMOUNT: {level: 'ERROR'},
    RECHARGE_POINT_UNAVAILABLE: {level: 'ERROR'},
    UNEXPECTED_ERROR: {level: 'ERROR'},
    BLANK_DELIVERY_ADDRESS_GIFTING: {level: 'ERROR'},
    NOT_INCLUDED_KOREAN_IN_BASE_ADDRESS: {level: 'WARN'},
    REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT: {level: 'WARN'},
    /** 수령위치를 선택해주세요. */
    INVALID_PICKUP_LOCATION_TYPE: {level: 'ERROR'},
    INVALID_ENTRY_METHOD_TYPE: {level: 'ERROR'},
    INVALID_LOBBY_PW_ENTRY_METHOD_CONTENT: {level: 'ERROR'},
    INVALID_OTHER_ENTRY_METHOD_CONTENT: {level: 'ERROR'},
    INVALID_ENTRY_METHOD_CONTENT_SIZE: {level: 'ERROR'},
    INVALID_PICKUP_LOCATION_CONTENT: {level: 'ERROR'},
    INVALID_PICKUP_LOCATION_CONTENT_SIZE: {level: 'ERROR'},
    INVALID_SELECTED_PRODUCT_DISCOUNT: {level: 'ERROR'},
    INVALID_SELECTED_IMMEDIATE_DISCOUNT: {level: 'ERROR'},
    DUPLICATED_SELECTED_STORE_COUPON: {level: 'ERROR'},
    INVALID_SELECTED_STORE_COUPON: {level: 'ERROR'},
    TOTAL_PURCHASE_LIMIT: {level: 'WARN'},
    PRODUCT_PRICE: {level: 'WARN'},
    PRODUCT_STATUS: {level: 'WARN'},
    PRODUCT_GROUP_BUYING_INFO: {level: 'WARN'},
    PRODUCT_STOCK_QUANTITY: {level: 'WARN'},
    PRODUCT_TYPE: {level: 'WARN'},
    PRODUCT_NAME_EMPTY: {level: 'WARN'},
    ADULT_ONLY_PURCHASE: {level: 'WARN'},
    CART_RESTRICT: {level: 'WARN'},
    SUBSCRIPTION: {level: 'WARN'},
    BLACKCONSUMER: {level: 'WARN'},
    BRANCH_BENEFIT: {level: 'WARN'},
    INVALID_BRANCH_DELIVERY: {level: 'WARN'},
    INVALID_BRANCH_IMMEDIATE_DELIVERY: {level: 'WARN'},
    DELIVERY_METHOD: {level: 'WARN'},
    HOPE_DELIVERY_DATE_REJECT: {level: 'WARN'},
    HOPE_DELIVERY_DATE_NEED: {level: 'WARN'},
    HOPE_DELIVERY_DATE_STATUS: {level: 'WARN'},
    OPTION_INFO: {level: 'WARN'},
    STANDARD_GROUP_PRODUCT: {level: 'WARN'},
    OPTION_PRICE: {level: 'WARN'},
    OPTION_STATUS: {level: 'WARN'},
    OPTION_STOCK_QUANTITY: {level: 'WARN'},
    OPTION_OUT_OF_STOCK: {level: 'WARN'},
    SUPPLEMENT_INFO: {level: 'WARN'},
    SUPPLEMENT_PRICE: {level: 'WARN'},
    SUPPLEMENT_STATUS: {level: 'WARN'},
    SUPPLEMENT_STOCK_QUANTITY: {level: 'WARN'},
    ITEM_NOT_FOUND: {level: 'WARN'},
    IMMEDIATE_DISCOUNT: {level: 'WARN'},
    SPECIAL_DISCOUNT: {level: 'WARN'},
    MULTI_DISCOUNT: {level: 'WARN'},
    REALTIME_PRODUCT_INFO: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_DISCOUNT_AMOUNT: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_STATUS: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_QUANTITY: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_PRICE: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_FOUND: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_ERROR: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_EXCESS_CAPACITY: {level: 'WARN'},
    REALTIME_PRODUCT_INFO_DISCOUNT_AMT: {level: 'WARN'},
    DELIVERY_ATTRIBUTE_CHANGE: {level: 'WARN'},
    FAIL_ADDRESS: {level: 'WARN'},
    FAIL_DELIVERY_BUNDLE: {level: 'WARN'},
    FAIL_ERROR: {level: 'WARN'},
    FAIL_DELIVERY_PLAN: {level: 'WARN'},
    PRODUCT_TAKING_GOODS_PLACE: {level: 'WARN'},
    TODAY_DISPATCH_STOCK_QUANTITY: {level: 'WARN'},
    PRE_ORDER_REJECT: {level: 'WARN'},
    MAX_PURCHASE_QUANTITY: {level: 'WARN'},
    MIN_PURCHASE_QUANTITY: {level: 'WARN'},
    CHANNEL_STATUS: {level: 'WARN'},
    EXHAUSTED_USER_PURCHASE_QUANTITY: {level: 'WARN'},
    EXCESS_USER_PURCHASE_QUANTITY: {level: 'WARN'},
    INVALID_GIFTING: {level: 'WARN'},
    INVALID_GIFTING_RECEIVER: {level: 'WARN'},
    INVALID_GIFTING_E_COUPON_AND_DELIVERY_METHOD_TYPE: {level: 'WARN'},
    INVALID_MAKE_ORDER_ARRIVAL_GUARANTEE: {level: 'WARN'},
    EXCEED_MAXIMUM_GIFTING_PRODUCT_ORDER_COUNT: {level: 'WARN'},
    NOT_MATCHED_FRIENDS_COUNT: {level: 'WARN'},
    EXCEED_MAXIMUM_FRIENDS_COUNT: {level: 'WARN'},
    EXCEED_AVAILABLE_FRIENDS_COUNT: {level: 'WARN'},
    INVALID_GIFTING_DELIVERY: {level: 'WARN'},
    FAILED_GET_RBBAG_DEPOSIT: {level: 'WARN'},
    INVALID_RBBAG_DEPOSIT: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_API: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_MERCHANT_IMMEDIATE_DISCOUNT: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ADDRESS: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ATTRIBUTE: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_OUTBOUND_LOCATION: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_NOT_FOUND: {level: 'WARN'},
    FAIL_OUTBOUND_LOCATION: {level: 'WARN'},
    DELIVERY_COMPANY_CHANGE: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_BUNDLE_GROUP_BY_OPTION: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_PLAN: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_ERROR: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_PRICE: {level: 'WARN'},
    FAILED_CHECK_PRODUCT_STOCK_QUANTITY: {level: 'WARN'},
    INVALID_CHECK_FULFILLMENT_PRODUCT_STOCK: {level: 'WARN'},
    INVALID_PRODUCT_STATUS_ON_ORDER_SHEET_VIEW: {level: 'WARN'},
    UNKNOWN_LOUNGE_MEMBER: {level: 'WARN'},
    NOT_LOUNGE_MEMBER: {level: 'WARN'},
    IDENTITY_VERIFICATION_FAILED: {level: 'WARN'},
    SMART_STORE_UNDER_MAINTENANCE: {level: 'WARN'},
    EXCEPTIONAL_CATEGORY_OVER_DISCOUNT_RATE: {level: 'WARN'},
    CONFLICT_DISCOUNT: {level: 'WARN'},
    DISCOUNT_OVER_PAY_AMOUNT: {level: 'WARN'},
    CARD_COMPANY_ID_EMPTY: {level: 'WARN'},
    CARD_PROMOTION_AGGREGATE_FAILED: {level: 'WARN'},
    CARD_PROMOTION_POLICY_PARTICIPATION_GET_FAILED: {level: 'WARN'},
    CARD_PROMOTION_POLICY_CARD_DETAIL_EMPTY: {level: 'WARN'},
    CARD_PROMOTION_APPLY_TYPE_ERROR: {level: 'WARN'},
    CARD_PROMOTION_NOT_MATCHED_ORDER_SHEET_ITEM_ID: {level: 'WARN'},
    INVALID_CARD_PROMOTION: {level: 'WARN'},
    INVALID_CARD_PROMOTION_DISCOUNT_AMOUNT: {level: 'WARN'},
    INVALID_CARD_PROMOTION_STATE: {level: 'WARN'},
    CARD_PROMOTION_VALIDATION_FAILED: {level: 'WARN'},
    POINT_PROMOTION_VALIDATION_FAILED: {level: 'WARN'},
    CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_ADULT: {level: 'WARN'},
    CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_MINOR: {level: 'WARN'},
    CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_NO_ACCOUNT_REGISTRATION_HISTORY: {
        level: 'WARN',
    },
    CARD_PROMOTION_MEMBERSHIP_VALIDATION_FAILED: {level: 'WARN'},
    AVAILABLE_GIFTING_FRIENDS_LIMIT: {level: 'WARN'},
    ECOUPON_AND_DELIVERY_TOGETHER_IN_CART_ORDER_GIFTING: {level: 'WARN'},
    VALIDATION_FAILED: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. (조회시 에러, 카드 프로모션) */
    GENERAL_ERROR: {level: 'WARN'},
    /** 주로 C1 v1/v2 가맹점 에러 */
    INVALID_PARAMETER: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. (서버 에러) */
    EXTERNAL_SERVER_ERROR: {level: 'WARN'},
    EXTERNAL_SERVER_WARNING: {level: 'WARN'},
    UNSUPPORTED_ENUM_CODE: {level: 'WARN'},
    BUSINESS_INVALID: {level: 'WARN'},
    RULE_VIOLATION: {level: 'WARN'},
    MESSAGE_ENCRYPTION_FAILED: {level: 'WARN'},
    KAFKA_CONSUMER_NOT_RETRYABLE: {level: 'WARN'},
    KAFKA_CONSUMER_NOT_RECOVERABLE: {level: 'WARN'},
    MEMBER_NOT_FOUND: {level: 'WARN'},
    DUPLICATE_PHONE_USER_NOT_FOUND: {level: 'WARN'},
    ORDER_NOT_FOUND: {level: 'WARN'},
    ORDER_ALREADY_PERSISTED: {level: 'WARN'},
    QUICK_JOIN_MEMBERSHIP_FAILED_UNCATEGORIZED_ERROR: {level: 'WARN'},
    QUICK_JOIN_MEMBERSHIP_FAILED_ALREADY_SUBSCRIBED: {level: 'WARN'},
    QUICK_JOIN_MEMBERSHIP_FAILED_ALREADY_SUBSCRIBED_WITH_NAVER_ID: {level: 'WARN'},
    QUICK_JOIN_MEMBERSHIP_FAILED_RESUBSCRIBE_ON_THE_SAME_DAY: {level: 'WARN'},
    URL_HMAC_ENCRYPTION_FAILED: {level: 'WARN'},
    DELIVERY_ADDRESS_NOT_AGREED: {level: 'WARN'},
    DELIVERY_ADDRESS_FOR_SUBSCRIPTION: {level: 'WARN'},
    REMOVE_DELIVERY_ADDRESS_FAILED_ALREADY_REMOVED: {level: 'WARN'},
    AVAILABLE_CARD_NOT_EXISTS: {level: 'WARN'},
    ENTER_TICKET_NOT_FOUND: {level: 'WARN'},
    INVALID_COUPON_PUBLICATION: {level: 'WARN'},
    API_EASYBOOKING_OUT_OF_STOCK: {level: 'WARN'},
    API_EASYBOOKING_CHECK_STOCK_FAILED: {level: 'WARN'},
    GET_PURCHASER_COMMISSIONS_FAILED: {level: 'WARN'},
    GET_CHARGE_POINT_USER_FAILED: {level: 'WARN'},
    GET_RECHARGEABLE_AMOUNT_FAILED: {level: 'WARN'},
    GET_CHARGE_POINT_FAILED_REQUEST_EXCEEDED: {level: 'WARN'},
    MERCHANT_NOT_FOUND: {level: 'WARN'},
    MERCHANT_NO_NOT_FOUND: {level: 'WARN'},
    GET_GIFTING_FRIENDS_SESSION_FAILED: {level: 'WARN'},
    GET_GIFTING_PLAYER_IDS_FAILED: {level: 'WARN'},
    GET_SSG_DEPOSIT_FAILED: {level: 'WARN'},
    SELLER_MERCHANT_NO_NOT_FOUND: {level: 'WARN'},
    GET_PURCHASE_COUNT_FAILED: {level: 'WARN'},
    APPROVE_PAY_NEXT_PAYMENT_FAIL: {level: 'WARN'},
    GET_DELIVERY_SLOT_FAIL: {level: 'WARN'},
    GET_REWARD_POLICY_FAILED: {level: 'WARN'},
    SELLER_MERCHANT_ADDRESS_BOOK_NOT_FOUND: {level: 'WARN'},
    SELLER_MERCHANT_NOT_FOUND: {level: 'WARN'},
    ISSUE_VIRTUAL_PHONE_NUMBER_FAILED: {level: 'WARN'},
    INVALID_PHONE_NUMBER_FOR_ISSUING_VIRTUAL_PHONE_NUMBER: {level: 'WARN'},
    DIRECT_ORDER_PAY_METHOD_NOT_FOUND: {level: 'WARN'},
    BILLING_BAD_REQUEST: {level: 'WARN'},
    BILLING_MERCHANT_NOT_FOUND: {level: 'WARN'},
    BILLING_ITEM_NOT_FOUND: {level: 'WARN'},
    BILLING_PRE_APPROVE_FAIL: {level: 'WARN'},
    BILLING_PAYMENT_FAIL: {level: 'WARN'},
    BILLING_RECHARGE_POINT_FAIL: {level: 'WARN'},
    BILLING_POINT_FAIL: {level: 'WARN'},
    BILLING_SERVER_ERROR: {level: 'WARN'},
    BILLING_PG_ERROR: {level: 'WARN'},
    BILLING_ERROR: {level: 'WARN'},
    /** 쿠폰승인 실패 메시지 업데이트 필요 apply_coupons(coupon_approve_fail) */
    COUPON_APPROVE_FAIL: {level: 'WARN'},
    PERSIST_PAYMENT_FAIL: {level: 'WARN'},
    CASH_RECEIPT_FAIL: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. approve_billing_payment(external_server_error)) */
    PAYMENT_ERROR: {level: 'WARN'},
    NOT_IMPLEMENTED: {level: 'WARN'},
    MEMBER_NOT_AGREED: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. (주문서 조회) */
    INVALID_MEMBER_STATUS: {level: 'WARN'},
    INVALID_REGISTER_ORDER: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. (주문서 조회) */
    ORDER_SHEET_ASSEMBLE_FAILED: {level: 'WARN'},
    GET_ADDITIONAL_DELIVERY_FEE_FAIL: {level: 'WARN'},
    ORDER_PROCESS_NOT_FOUND: {level: 'WARN'},
    APPLY_ORDER_PROCESS_TIMEOUT: {level: 'WARN'},
    INVALID_ORDER_PROCESS_STATE: {level: 'WARN'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. 결제중 */
    ORDER_PROCESS_ERROR: {level: 'WARN'},
    PERSIST_ORDER_FAILED: {level: 'WARN'},
    COMPLETE_ORDER_FAILED: {level: 'WARN'},
    EASYBOOKING_OUT_OF_STOCK: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_FAILED: {level: 'WARN'},
    INVALID_EASYBOOKING_CHECK_STOCK_REQUEST: {level: 'WARN'},
    CAFE_CHECK_STOCK_FAILED: {level: 'WARN'},
    BLOG_OUT_OF_STOCK: {level: 'WARN'},
    BLOG_REDUCE_STOCK_FAILED: {level: 'WARN'},
    DIRECT_ORDER_PROCESS_TIMEOUT: {level: 'WARN'},
    REFLECT_CARD_PROMOTION_BAD_REQUEST: {level: 'WARN'},
    REFLECT_CARD_PROMOTION_BUDGET_FAILED: {level: 'WARN'},
    REDUCE_STOCK_FAILED: {level: 'WARN'},
    REDUCE_STOCK_OUT_OF_STOCK: {level: 'WARN'},
    REDUCE_STOCK_INVALID_MERCHANT_IMMEDIATE_DISCOUNT: {level: 'WARN'},
    REDUCE_STOCK_READ_TIMEOUT: {level: 'WARN'},
    SSG_DEPOSIT_QUERY_FAILED: {level: 'WARN'},
    INVALID_GIFTING_EDITOR: {level: 'WARN'},
    DISCOUNT_CONFLICT: {level: 'WARN'},
    DISCOUNT_OVER_FIXED_TRADITIONAL_ALCOHOL_RATE: {level: 'WARN'},
    GIFTING_PLAYER_KEY_EMPTY: {level: 'WARN'},
    DISCOUNT_OVER_FIXED_BOOK_RATE: {level: 'WARN'},
    /** 주문상태가 유효화지 않습니다. */
    INVALID_ORDER_STATUS: {level: 'ERROR'},
    /** 주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다. (나중에결제 만료) */
    PAYMENT_DUE_DATE_EXPIRED: {level: 'WARN'},
    INVALID_PAY_METHOD_TYPE: {level: 'ERROR'},
    BLANK_MALL_PRODUCT_NAME: {level: 'WARN'},
    NONEXISTENT_MALL_PRODUCT: {level: 'WARN'},
    NULL_PRODUCT_URL: {level: 'WARN'},
    // 결제수단 정보를 전달하지 않음
    INVALID_PAY_NEXT_PAY_METHOD_TYPE: {level: 'ERROR'},
    INVALID_PAY_METHOD: {level: 'ERROR'},
    INVALID_PAY_METHOD_CARD_COMPANY_CODE: {level: 'ERROR'},
    INVALID_PAY_METHOD_MOBILE_PHONE_NUMBER: {level: 'ERROR'},
    INVALID_PAY_METHOD_MOBILE_EASY_PAY_PIN: {level: 'ERROR'},
    INVALID_PAY_METHOD_BANK_CODE: {level: 'ERROR'},
    INVALID_PAY_METHOD_INSTALLMENT_MONTH: {level: 'ERROR'},
    INVALID_PAY_METHOD_INSTALLMENT_CARD_OWNER_TYPE: {level: 'ERROR'},
    NOT_PERMITTED_INSTALLMENT_FOR_CHECK_CARD: {level: 'ERROR'},
    INVALID_ORDER_NO: {level: 'WARN'},
    UNKNOWN_PAY_METHOD_TYPE: {level: 'ERROR'},
    INVALID_PAY_LATER_PRODUCT_TYPE: {level: 'ERROR'},
    INVALID_PAY_LATER_WITH_PAY_NEXT: {level: 'ERROR'},
    INVALID_PAY_LATER_WITH_CHARGE_POINT: {level: 'ERROR'},
    INVALID_PAY_AMOUNT: {level: 'ERROR'},
    INVALID_GENERAL_PAY_AMOUNT: {level: 'ERROR'},
    INVALID_DIFFERENT_PAY_METHOD_TYPE: {level: 'ERROR'},
    DEFAULT_ERROR_MESSAGE: {level: 'ERROR'},
    INQUIRE_ORDER_SHEET_FAILED: {level: 'ERROR'},
    FREE_INSTALLMENT_MONTH_LIMIT_EXCEEDED: {level: 'ERROR'},
    INVALID_ORDERPROCESS_ID: {level: 'ERROR'},
    /** 유효화지 않은 회원입니다. */
    ORDER_PAY_MEMBER_NO_NOT_MATCHED: {level: 'WARN'},
    FREE_INTEREST_INSTALLMENT_MONTH_LIMIT_EXCEEDED: {level: 'ERROR'},
    DUPLICATE_ORDER_SHEET_ID: {level: 'WARN'},
    ORDER_PROCESS_ALREADY_STARTED: {level: 'INFO'},
    INVALID_FAMILY_PAY_AVAILABLE: {level: 'INFO'},
    NOT_FAMILY_PAY_ORDER: {level: 'INFO'},
    NOT_SUBSCRIBED_MEMBERSHIP: {level: 'INFO'},
    NOT_SAME_MEMBERSHIP_ORGANIZER: {level: 'INFO'},
    INVALID_MEMBERSHIP_TYPE: {level: 'INFO'},
    INVALID_FAMILY_PAY_MEMBER_NO: {level: 'INFO'},
    NOT_AGREE_FAMILY_PAY_TERM: {level: 'INFO'},
    INVALID_SALE_CHANNEL_TYPE_FOR_FAMILY_PAY: {level: 'INFO'},
    INVALID_PRODUCT_FOR_FAMILY_PAY: {level: 'INFO'},
    INVALID_FAMILY_PAY_API_RESPONSE: {level: 'INFO'},
    INVALID_FAMILY_PAY_PAYER_MEMBER_NO: {level: 'INFO'},
    EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT_PER_ORDER: {level: 'WARN'},
    EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT: {level: 'WARN'},
    UNAVAILABLE_FAMILY_PAY_PRE_APPROVAL_PAYMENT: {level: 'WARN'},
    PERSONAL_CUSTOMS_CLEARANCE_CHECK_FAIL: {level: 'WARN'},
    UNKNOWN: {level: 'WARN'},
    UNREGISTERED_SELLER: {level: 'INFO'},
    INVALID_EXPECTED_REWARD_POINT_FETCH_BY_INVALID_FAMILY_PAY_INFO: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_ETC_ERROR: {level: 'WARN'},
    EASYBOOKING_SLOT_INVALID_SELECTION: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_SHIPPING_INVALID: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_PAYMENT_ERROR: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_PAYMENT_DUPLICATED_ERROR: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_PAYMENT_DEADLINE_OVER: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_OPTION_STALE: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_OPTION_INVALID_SELECTION: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_LOGIN_ERROR: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_INTERNAL_SERVER_ERROR: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_COUPON_INVALID_TO_USE: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_BOOKING_UNAVAILABLE: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_BIZ_ITEM_STALE: {level: 'WARN'},
    EASYBOOKING_CHECK_STOCK_BOOKING_DUPLICATED: {level: 'WARN'},
    ANONYMOUS_DEFAULT_ERROR: {level: 'WARN'},
    EXPIRED_OVERSEA_EASY_CARD: {level: 'WARN'},
    EXCEED_FOREIGNER_ORDER_PAY_AMOUNT: {level: 'WARN'},
    PRODUCT_MULTI_OPTION_TYPE: {level: 'WARN'},
    DELIVERY_SCHEDULE: {level: 'WARN'},
    FAIL_RESTRICTED_AREA: {level: 'WARN'},
    NOT_PURCHASABLE_FLEAMARKET_PRODUCT: {level: 'INFO'},
}
